// Base domain configuration for API endpoints
const BASE_DOMAIN = "https://vancouverlookout.thedev.ca/";
// const BASE_DOMAIN = "https://vancouverlookout.com/";

// Construct API base URL
export const API_BASE_URL = `${BASE_DOMAIN}/wp/wp-json/custom/v1`;

// Export base domain if needed elsewhere
export default BASE_DOMAIN;

